// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Share_Logo__3922T","Header":"Share_Header__2ILKO","Main":"Share_Main__3AuRb"};